//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSectionList } from '@/api/section'
import { find } from 'lodash'
import { sortBy } from 'lodash'
import PageButtonClose from '@/components/PageButton/Close'


export default {
  name: 'Section',
  components: { PageButtonClose },
  data () {
    // console.log(this.$route.params.id)
    return {
      id: this.$route.params.id,
      // id: process.env.NODE_ENV === 'production' ? 1 : 6,
      scrollPos: 0,
      dialogSectionPopup: false,
      sectionNow: {},
      group: {
        name: undefined,
        content: undefined,
      },
      section: {
        name: undefined,
        content: undefined,
      },
      artworks: undefined,
      contents: undefined,
      sections: undefined
    }
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    langNotEn() {
      return localStorage.getItem('keio.lang') !== 'en';
    }
  },
  methods: {
      async fetchData() {
          const sectionList = await getSectionList();
          const sectionNow = find(sectionList, { id: `${this.id}` })
          if (!sectionNow) this.$router.push({ name: 'Error', params: { status: 404 } })
          // console.log(sectionList)
          this.sectionNow = sectionNow
          this.group.name = sectionNow.groupName
          this.group.content = sectionNow.groupContent
          this.section.name = sectionNow.name
          this.section.content = sectionNow.content
          this.artworks = sortBy(sectionNow.artworks, [function(o) { return o.title; }])
          this.sections = sectionList.filter(v => v.id !== `${this.id}`)
          // console.log(222)
          // console.log(sectionNow)
          // this.contents = uniqBy(flattenDeep(sectionList.map(v => v.artworks.map(vv => vv.contents))), 'id');
          this.contents = sectionNow.contents
      },
      handleScroll (event) {
        // console.log('handleScroll')
        // increase scroll speed
        this.scrollPos += event.deltaY * 4

        if (this.scrollPos < 0) {
          this.scrollPos = 0
        }
        
        const scrollArea = this.$refs.scrollArea;
        const scrollTarget = scrollArea.getScrollTarget();
        // screen width
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        const maxPos = scrollTarget.scrollWidth - vw

        if (this.scrollPos > maxPos) {
          this.scrollPos = maxPos
        }
        scrollArea.setScrollPosition(this.scrollPos)
        event.preventDefault()
      },
  }
}
